export function EmptyState(props: { title: string; hint?: string }) {
  return (
    <div class="empty">
      <div class="empty-title">{props.title}</div>
      {props.hint ? <div class="empty-hint">{props.hint}</div> : null}
    </div>
  );
}
